import GuestI from '../interfaces/Guest';

const getGuest = (id: string, guests: GuestI[]) =>
    guests.find(({ _id }: GuestI) => _id === id);

export default getGuest;
